import { render, staticRenderFns } from "./RuleValues.vue?vue&type=template&id=4f4283fc&scoped=true&"
import script from "./RuleValues.vue?vue&type=script&lang=js&"
export * from "./RuleValues.vue?vue&type=script&lang=js&"
import style0 from "./RuleValues.vue?vue&type=style&index=0&id=4f4283fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4283fc",
  null
  
)

export default component.exports